import { Skeleton } from "@/components/ui/skeleton";

export function ProductCardSkeleton() {
  return (
    <div className="bg-card border border-border rounded-2xl p-4">
      <div className="flex items-start gap-4">
        {/* Logo Skeleton */}
        <Skeleton className="w-20 h-20 rounded-xl flex-shrink-0" />

        {/* Content Skeleton */}
        <div className="flex-1 min-w-0 space-y-3">
          {/* Title + Status Dots */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-2.5 w-2.5 rounded-full" />
            <Skeleton className="h-2.5 w-2.5 rounded-full" />
          </div>

          {/* Tagline */}
          <Skeleton className="h-4 w-full max-w-md" />

          {/* Categories */}
          <div className="flex gap-2">
            <Skeleton className="h-6 w-20 rounded-full" />
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-6 w-16 rounded-full" />
          </div>

          {/* Footer: metrics + actions */}
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-4 w-12" />
            <div className="flex items-center gap-1 ml-auto">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-6 rounded-full" />
              <Skeleton className="h-4 w-20" />
            </div>
          </div>
        </div>

        {/* Vote Button Skeleton */}
        <Skeleton className="w-14 h-16 rounded-xl flex-shrink-0" />
      </div>
    </div>
  );
}
